import { Box, Stack, Meter, Text, Heading } from "grommet";
import { algorithms } from "../../task-specific/algorithms/algorithms";

export interface PredictionProps {
  sliders: number[];
}

export function Prediction({ sliders }: PredictionProps): React.ReactElement {
  return (
    <Box flex={{ shrink: 0 }} gap="small">
      {sliders &&
        algorithms.map((algorithm) => {
          return (
            <Box round="small" border={{ color: "light-3", size: "medium" }} pad="medium">
              <Box>
                <Stack anchor="bottom">
                  <Box align="end" justify="center" direction="row">
                    <Box style={{ position: "absolute" }}>
                      <Meter
                        type="semicircle"
                        background="light-4"
                        values={[{ value: algorithm.baseValue, color: "black" }]}
                        size="155px"
                        thickness="3px"
                        max={100}
                      />
                    </Box>
                    <Box style={{ position: "relative" }}>
                      <Meter
                        type="semicircle"
                        background="light-2"
                        values={[{ value: algorithm.probability(sliders), color: algorithm.colors[algorithm.probability(sliders)] }]}
                        size="150px"
                        thickness="20px"
                        max={100}
                      />
                    </Box>
                  </Box>
                  <Box direction="row" align="center">
                    <Text size="xxlarge" weight="bold">
                      {algorithm.probability(sliders)}
                    </Text>
                    <Text size="mediun">%</Text>
                  </Box>
                </Stack>
              </Box>
              <Heading textAlign="center" level={5} margin={{ top: "medium", bottom: "none" }}>
                {algorithm.text}
              </Heading>
            </Box>
          );
        })}
    </Box>
  );
}
